import React from "react";
import { Formik } from "formik";
import {
    TextField,
    withStyles,
    Button,
    Typography,
    Paper,
    FormGroup,
    FormControlLabel,
    Checkbox,
    Chip
} from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import * as Yup from "yup";
import { BackButton } from '../../sc-utilities';

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
    cancel: {
        width: "120px",
        marginTop: "10px",
        marginRight: "10px",
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        }
    },
    formControl: {
        width: "100%"
    },
    buttons: {
        textAlign: 'right'
    }
});

const ColliTypeForm = props => {
    const { classes, formSettings, initialValues, handleSubmit, translations, colliTypes, productTypes } = props;

    return (
        <Paper className={classes.root}>
            {BackButton(translations)}
            <Formik
                enableReinitialize
                initialValues={initialValues}
                onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(true);
                    handleSubmit(values);
                    setSubmitting(false);
                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, handleChange, setFieldValue, handleBlur, handleSubmit, isSubmitting } = formikProps;

                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <TextField
                                name="Name"
                                value={values.Name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Name && touched.Name)}
                                placeholder={translations["name"] || "Name"}
                                label={translations["name"] || "Name"}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="Height"
                                value={values.Height}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Height && touched.Height)}
                                placeholder={translations["height"] || "Height"}
                                label={translations["height"] || "Height"}
                                margin={"dense"}
                                fullWidth={true}
                                type={"number"}
                            />
                            <TextField
                                name="Width"
                                value={values.Width}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Width && touched.Width)}
                                placeholder={translations["width"] || "Width"}
                                label={translations["width"] || "Width"}
                                margin={"dense"}
                                fullWidth={true}
                                type={"number"}
                            />
                            <TextField
                                name="Length"
                                value={values.Length}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Length && touched.Length)}
                                placeholder={translations["length"] || "Length"}
                                label={translations["length"] || "Length"}
                                margin={"dense"}
                                fullWidth={true}
                                type={"number"}
                            />
                            <TextField
                                name="MaxWeight"
                                value={values.MaxWeight}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.MaxWeight && touched.MaxWeight)}
                                placeholder={translations["max_weight"] || "Max weight"}
                                label={translations["max_weight"] || "Max weight"}
                                margin={"dense"}
                                fullWidth={true}
                                type={"number"}
                            />
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            margin={"dense"}
                                            name={"AllowHolderColliIDNull"}
                                            checked={values.AllowHolderColliIDNull}
                                            onChange={handleChange}
                                            color={'primary'}
                                        />
                                    }
                                    label={translations["without_holder_colli"] || "Allow having no holder"}
                                />
                            </FormGroup>
                            <Autocomplete
                                name={'HolderColliTypeIDs'}
                                multiple
                                id="holder_colli_type_select"
                                options={colliTypes || []}
                                getOptionLabel={(option) => option.displayValue}
                                filterSelectedOptions
                                value={values.HolderColliTypeIDs}
                                onChange={(_, value) => { setFieldValue('HolderColliTypeIDs', value) }}
                                onBlur={handleBlur}
                                renderInput={(params) => (
                                    <TextField {...params} variant="standard" fullWidth={true} label={`${translations["colli_type_select"] || "Allowed holder colli types"}...`} />
                                )}
                                renderTags={(value, getTagProps) =>
                                    value.map((option, index) => (
                                        <Chip label={option.displayValue} {...getTagProps({ index })} />
                                    ))
                                }
                            />
                            <Autocomplete
                                name={'ProductTypeIDs'}
                                multiple
                                id="ProducTypeMultiSelect"
                                options={productTypes || []}
                                getOptionLabel={(option) => option.label}
                                filterSelectedOptions
                                value={values.ProductTypeIDs}
                                onChange={(_, value) => { setFieldValue('ProductTypeIDs', value) }}
                                onBlur={handleBlur}
                                renderInput={(params) => (
                                    <TextField {...params} variant="standard" fullWidth={true} label={`${translations["choose_product_type"] || "Choose product type"}...`} />
                                )}
                                renderTags={(value, getTagProps) =>
                                    value.map((option, index) => (
                                        <Chip label={option.label} {...getTagProps({ index })} />
                                    ))
                                }
                            />
                            <div className={classes.buttons}>
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        className={classes.submit}
                                        variant="contained"
                                        type="submit"
                                        disabled={isSubmitting || !(isValid && dirty)}
                                    >
                                        { formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </Paper>
    );
};

export default withStyles(styles, { withTheme: true })(ColliTypeForm);


/**
 * Translations:
 *  name
 *  width
 *  height
 *  max_weight
 */